/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2017, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../../DynamicFileLoader'
], function (
	DynamicFileLoader
) {
	class RelinkUtils {
		static relink (source, newSourceInfo, dashboardApi) {
			const oldCMAssetId = source.getAssetId();
			return dashboardApi.getFeature('.LifeCycleManager').invokeLifeCycleHandlers('pre:relink')
				.then(() =>
					Promise.all([
						source.relink(newSourceInfo),
						DynamicFileLoader.load(['dashboard-analytics/dataSources/utils/RelinkItemIdInSpec'])
					]))
				.then( Results => {
					let logger = dashboardApi.getGlassCoreSvc('.Logger');
					const sourceInfo = Results[0];
					const RelinkItemIdInSpec = Results[1][0];
					let newDashboardJSONSpec;
					const oldDashboardSpec = dashboardApi.getFeature('internal').getBoardModel().toJSON();
					if (sourceInfo) {
						const newCMAssetId =newSourceInfo.assetId;
						const relinkItemIdInSpec = new RelinkItemIdInSpec(oldDashboardSpec, { sourceId: sourceInfo.sourceId, oldCMAssetId: oldCMAssetId, newCMAssetId: newCMAssetId }, logger);
						const oldItemIds = relinkItemIdInSpec.getItemIds();
						const newItemIds = sourceInfo.relinkIdForExpressions(oldItemIds);
						newDashboardJSONSpec = relinkItemIdInSpec.replaceItemIds(newItemIds);
					}

					//relink is only supported for uploaded files. For non-uploaded files use the oldDashboardSpec since newDashboardJSONSpec is undefined
					return dashboardApi.reloadFromJSONSpec(newDashboardJSONSpec || oldDashboardSpec);
				})
				.then((dashboardApi) => {
					return dashboardApi.getFeature('.LifeCycleManager').invokeLifeCycleHandlers('post:relink');
				});
		}

	}

	return RelinkUtils;
});
